import axios from '@/http/axios';

export default {
  create: (config: any = {}) => {
    return axios.post(`/bookings/`, config);
  },
  delete: (bookingId) => {
    return axios.delete(`/bookings/${bookingId}`);
  },
  fetch: (bookingId, config: any = {}) => {
    return axios.get(`/bookings/${bookingId}`, config);
  },
  fetchList: (config: any = {}) => {
    return axios.get(`/bookings/`, config);
  },
  candidatePreFetch: (config: any = {}) => {
    return axios.put(`/bookings/candidate-pre-fetch`, config);
  },
  candidate: (bookingOid, bookingCandidateOid = null, config: any = {}) => {
    return axios.put(
      `/bookings/${bookingOid}/candidate/${
        bookingCandidateOid ? bookingCandidateOid : ''
      }`,
      config
    );
  },
  // consume: (paymentOid, bookingOid) => {
  //   return axios.put(`/bookings/${bookingOid}/consume`, {
  //     payment_oid: paymentOid
  //   })
  // },
  consume: (bookingOid) => {
    return axios.put(`/bookings/${bookingOid}/consume`);
  },
  checkCreditLimit: (bookingOid) => {
    return axios.get(`/bookings/${bookingOid}/check-credit-limit`);
  },
  cancel: (bookingOid) => {
    return axios.put(`/bookings/${bookingOid}/cancel`);
  },
};
